import bookingFollowups from '@/views/pages/bookingFollowups/messages'
import doctorPolicy from '@/views/pages/doctorPolicy/messages'
import operationalMessages from '@/views/pages/contentCampaign/operational-report-messages'
import campaignMessages from '@/views/pages/contentCampaign/messages'
import fa from './fa'
import campaignPermissions from './campaign-permissions'
import foundation from './foundation'

export default {
  fa: {
    bookingFollowups: bookingFollowups.fa,
    doctorPolicy: doctorPolicy.fa,
    ...fa,
    contentCampaigns: campaignMessages.fa,
    operationalReports: operationalMessages.fa,
    foundation: foundation.fa,
  },
  en: {
    bookingFollowups: bookingFollowups.en,
    doctorPolicy: doctorPolicy.en,
    contentCampaigns: campaignMessages.en,
    operationalReports: operationalMessages.en,
    permissions: campaignPermissions.en,
    foundation: foundation.en,
  },
  ar: {
    bookingFollowups: bookingFollowups.ar,
    doctorPolicy: doctorPolicy.ar,
    contentCampaigns: campaignMessages.ar,
    operationalReports: operationalMessages.ar,
    permissions: campaignPermissions.ar,
    foundation: foundation.ar,
  },
}
